export const getKommuneByKommuneKode = (kode: string) => {
  return kommuner.find((k) => parseInt(k.kode) === parseInt(kode));
};
export const kommuner = [
  {
    ændret: "2022-04-27T21:02:37.335Z",
    geo_version: 13,
    geo_ændret: "2022-04-27T21:02:37.335Z",
    bbox: [12.44441133, 55.60647026, 12.73658638, 55.73587822],
    visueltcenter: [12.49390862, 55.7040906],
    href: "https://api.dataforsyningen.dk/kommuner/0101",
    dagi_id: "389103",
    kode: "0101",
    navn: "København",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 4,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [12.49027876, 55.66556585, 12.55873518, 55.69896893],
    visueltcenter: [12.52373306, 55.67936546],
    href: "https://api.dataforsyningen.dk/kommuner/0147",
    dagi_id: "389104",
    kode: "0147",
    navn: "Frederiksberg",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2019-01-07T22:06:38.332Z",
    geo_version: 4,
    geo_ændret: "2019-01-07T22:06:38.332Z",
    bbox: [12.25958944, 55.69631008, 12.4301625, 55.76439116],
    visueltcenter: [12.36840182, 55.72775072],
    href: "https://api.dataforsyningen.dk/kommuner/0151",
    dagi_id: "389105",
    kode: "0151",
    navn: "Ballerup",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-08-27T21:10:28.421Z",
    geo_version: 3,
    geo_ændret: "2020-08-27T21:10:28.421Z",
    bbox: [12.35917289, 55.6062615, 12.46196914, 55.67369314],
    visueltcenter: [12.40438199, 55.64503727],
    href: "https://api.dataforsyningen.dk/kommuner/0153",
    dagi_id: "389106",
    kode: "0153",
    navn: "Brøndby",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-11-19T22:08:50.853Z",
    geo_version: 2,
    geo_ændret: "2020-11-19T22:08:50.853Z",
    bbox: [12.55362233, 55.53632022, 12.71832842, 55.61097821],
    visueltcenter: [12.65022813, 55.59380739],
    href: "https://api.dataforsyningen.dk/kommuner/0155",
    dagi_id: "389107",
    kode: "0155",
    navn: "Dragør",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-10-27T21:03:39.353Z",
    geo_version: 5,
    geo_ændret: "2021-10-27T21:03:39.353Z",
    bbox: [12.49620786, 55.72128423, 12.60725836, 55.78204727],
    visueltcenter: [12.55072009, 55.75097637],
    href: "https://api.dataforsyningen.dk/kommuner/0157",
    dagi_id: "389108",
    kode: "0157",
    navn: "Gentofte",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 3,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [12.41268755, 55.71506508, 12.52568184, 55.77742733],
    visueltcenter: [12.47620274, 55.73986832],
    href: "https://api.dataforsyningen.dk/kommuner/0159",
    dagi_id: "389109",
    kode: "0159",
    navn: "Gladsaxe",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-02-19T22:17:46.759Z",
    geo_version: 3,
    geo_ændret: "2021-02-19T22:17:46.759Z",
    bbox: [12.36701152, 55.65732844, 12.43412545, 55.71057297],
    visueltcenter: [12.40923426, 55.69595649],
    href: "https://api.dataforsyningen.dk/kommuner/0161",
    dagi_id: "389110",
    kode: "0161",
    navn: "Glostrup",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [12.38948631, 55.70676396, 12.46239931, 55.75989596],
    visueltcenter: [12.42581723, 55.74142756],
    href: "https://api.dataforsyningen.dk/kommuner/0163",
    dagi_id: "389111",
    kode: "0163",
    navn: "Herlev",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-02-19T22:17:46.759Z",
    geo_version: 5,
    geo_ændret: "2021-02-19T22:17:46.759Z",
    bbox: [12.30670903, 55.64055679, 12.39838032, 55.71188068],
    visueltcenter: [12.35232083, 55.68497735],
    href: "https://api.dataforsyningen.dk/kommuner/0165",
    dagi_id: "389112",
    kode: "0165",
    navn: "Albertslund",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2022-02-28T22:01:48.577Z",
    geo_version: 2,
    geo_ændret: "2022-02-28T22:01:48.577Z",
    bbox: [12.42233968, 55.59722923, 12.5101236, 55.66750471],
    visueltcenter: [12.46853361, 55.63137356],
    href: "https://api.dataforsyningen.dk/kommuner/0167",
    dagi_id: "389113",
    kode: "0167",
    navn: "Hvidovre",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-01-15T22:18:08.104Z",
    geo_version: 3,
    geo_ændret: "2020-01-15T22:18:08.104Z",
    bbox: [12.14527153, 55.60096989, 12.35246466, 55.71113732],
    visueltcenter: [12.25783217, 55.66695566],
    href: "https://api.dataforsyningen.dk/kommuner/0169",
    dagi_id: "389114",
    kode: "0169",
    navn: "Høje-Taastrup",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 5,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [12.41200531, 55.75671449, 12.59889114, 55.81406335],
    visueltcenter: [12.51127423, 55.78319075],
    href: "https://api.dataforsyningen.dk/kommuner/0173",
    dagi_id: "389115",
    kode: "0173",
    navn: "Lyngby-Taarbæk",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2015-10-15T21:43:23.848Z",
    bbox: [12.4224628, 55.66409113, 12.48267315, 55.71569384],
    visueltcenter: [12.44866158, 55.68180831],
    href: "https://api.dataforsyningen.dk/kommuner/0175",
    dagi_id: "389116",
    kode: "0175",
    navn: "Rødovre",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 3,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [12.20776504, 55.59302796, 12.40354463, 55.64120178],
    visueltcenter: [12.3344614, 55.6223754],
    href: "https://api.dataforsyningen.dk/kommuner/0183",
    dagi_id: "389118",
    kode: "0183",
    navn: "Ishøj",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-11-19T22:08:50.853Z",
    geo_version: 4,
    geo_ændret: "2020-11-19T22:08:50.853Z",
    bbox: [12.50576811, 55.56412556, 12.82943183, 55.68025855],
    visueltcenter: [12.55128121, 55.59508146],
    href: "https://api.dataforsyningen.dk/kommuner/0185",
    dagi_id: "389119",
    kode: "0185",
    navn: "Tårnby",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [12.33871222, 55.60934668, 12.4086825, 55.65682689],
    visueltcenter: [12.36571727, 55.63854285],
    href: "https://api.dataforsyningen.dk/kommuner/0187",
    dagi_id: "389120",
    kode: "0187",
    navn: "Vallensbæk",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-09-23T20:26:57.530Z",
    bbox: [12.29188392, 55.75163915, 12.44536587, 55.85335451],
    visueltcenter: [12.37121331, 55.78539677],
    href: "https://api.dataforsyningen.dk/kommuner/0190",
    dagi_id: "389122",
    kode: "0190",
    navn: "Furesø",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-04-14T20:39:11.464Z",
    bbox: [12.20602777, 55.80973767, 12.42940117, 55.9034465],
    visueltcenter: [12.31517796, 55.85193129],
    href: "https://api.dataforsyningen.dk/kommuner/0201",
    dagi_id: "389121",
    kode: "0201",
    navn: "Allerød",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 5,
    geo_ændret: "2018-01-01T22:10:40.972Z",
    bbox: [12.34085701, 55.8829944, 12.55163344, 56.0153342],
    visueltcenter: [12.44709475, 55.94248633],
    href: "https://api.dataforsyningen.dk/kommuner/0210",
    dagi_id: "389123",
    kode: "0210",
    navn: "Fredensborg",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 5,
    geo_ændret: "2018-01-01T22:10:40.972Z",
    bbox: [12.38516554, 55.97299219, 12.6294339, 56.09798427],
    visueltcenter: [12.48168066, 56.04907246],
    href: "https://api.dataforsyningen.dk/kommuner/0217",
    dagi_id: "389124",
    kode: "0217",
    navn: "Helsingør",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 3,
    geo_ændret: "2015-10-28T21:35:17.641Z",
    bbox: [12.07304508, 55.84073142, 12.40267468, 56.01042881],
    visueltcenter: [12.25951193, 55.93427514],
    href: "https://api.dataforsyningen.dk/kommuner/0219",
    dagi_id: "389125",
    kode: "0219",
    navn: "Hillerød",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-09-06T20:24:06.902Z",
    bbox: [12.3948758, 55.85180353, 12.56685583, 55.91684765],
    visueltcenter: [12.511463, 55.88879138],
    href: "https://api.dataforsyningen.dk/kommuner/0223",
    dagi_id: "389126",
    kode: "0223",
    navn: "Hørsholm",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 3,
    geo_ændret: "2017-02-22T22:05:19.098Z",
    bbox: [12.38898317, 55.79045664, 12.58856699, 55.88013588],
    visueltcenter: [12.47570388, 55.83467153],
    href: "https://api.dataforsyningen.dk/kommuner/0230",
    dagi_id: "389127",
    kode: "0230",
    navn: "Rudersdal",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-01-15T22:18:08.104Z",
    geo_version: 3,
    geo_ændret: "2019-01-07T22:06:38.332Z",
    bbox: [12.10266377, 55.69288512, 12.35202688, 55.83076527],
    visueltcenter: [12.21450626, 55.78610497],
    href: "https://api.dataforsyningen.dk/kommuner/0240",
    dagi_id: "389129",
    kode: "0240",
    navn: "Egedal",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 5,
    geo_ændret: "2017-02-16T01:34:32.750Z",
    bbox: [11.84322909, 55.70923571, 12.23827122, 55.93903413],
    visueltcenter: [11.97282557, 55.78185571],
    href: "https://api.dataforsyningen.dk/kommuner/0250",
    dagi_id: "389130",
    kode: "0250",
    navn: "Frederikssund",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2022-04-27T21:02:37.335Z",
    geo_version: 5,
    geo_ændret: "2022-04-27T21:02:37.335Z",
    bbox: [12.1356244, 55.55028631, 12.36543059, 55.62561748],
    visueltcenter: [12.24573777, 55.58551371],
    href: "https://api.dataforsyningen.dk/kommuner/0253",
    dagi_id: "389135",
    kode: "0253",
    navn: "Greve",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 4,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [11.90060679, 55.36450603, 12.24027656, 55.5365625],
    visueltcenter: [12.07253908, 55.45729905],
    href: "https://api.dataforsyningen.dk/kommuner/0259",
    dagi_id: "389136",
    kode: "0259",
    navn: "Køge",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2022-02-23T22:02:12.653Z",
    geo_version: 2,
    geo_ændret: "2022-02-23T22:02:12.653Z",
    bbox: [11.65390488, 55.87734531, 12.14477654, 56.20520188],
    visueltcenter: [12.00269823, 55.99570917],
    href: "https://api.dataforsyningen.dk/kommuner/0260",
    dagi_id: "389131",
    kode: "0260",
    navn: "Halsnæs",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-01-15T22:18:08.104Z",
    geo_version: 3,
    geo_ændret: "2020-01-15T22:18:08.104Z",
    bbox: [11.96845636, 55.51074815, 12.25656391, 55.78353567],
    visueltcenter: [12.10731038, 55.62237213],
    href: "https://api.dataforsyningen.dk/kommuner/0265",
    dagi_id: "389137",
    kode: "0265",
    navn: "Roskilde",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 3,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [12.09239684, 55.5068449, 12.25587577, 55.56922308],
    visueltcenter: [12.17912103, 55.53274198],
    href: "https://api.dataforsyningen.dk/kommuner/0269",
    dagi_id: "389138",
    kode: "0269",
    navn: "Solrød",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2020-01-15T22:18:08.104Z",
    geo_version: 2,
    geo_ændret: "2015-10-16T21:45:38.006Z",
    bbox: [12.00418864, 55.9622213, 12.41972846, 56.13737083],
    visueltcenter: [12.28643438, 56.06440048],
    href: "https://api.dataforsyningen.dk/kommuner/0270",
    dagi_id: "389132",
    kode: "0270",
    navn: "Gribskov",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2020-08-11T21:09:28.469Z",
    geo_version: 3,
    geo_ændret: "2020-08-11T21:09:28.469Z",
    bbox: [11.26094402, 55.72536886, 11.79587112, 56.01063775],
    visueltcenter: [11.60073899, 55.85125463],
    href: "https://api.dataforsyningen.dk/kommuner/0306",
    dagi_id: "389139",
    kode: "0306",
    navn: "Odsherred",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2019-01-07T22:06:38.332Z",
    geo_version: 2,
    geo_ændret: "2019-01-07T22:06:38.332Z",
    bbox: [11.34354886, 55.50500271, 11.87586633, 55.81898603],
    visueltcenter: [11.54590752, 55.67010311],
    href: "https://api.dataforsyningen.dk/kommuner/0316",
    dagi_id: "389140",
    kode: "0316",
    navn: "Holbæk",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 3,
    geo_ændret: "2017-02-16T01:34:32.750Z",
    bbox: [11.8197142, 55.12860752, 12.29735067, 55.40818727],
    visueltcenter: [12.0936263, 55.27387359],
    href: "https://api.dataforsyningen.dk/kommuner/0320",
    dagi_id: "389143",
    kode: "0320",
    navn: "Faxe",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2021-06-09T21:01:24.204Z",
    geo_version: 3,
    geo_ændret: "2021-06-09T21:01:24.204Z",
    bbox: [10.85522694, 55.45595543, 11.48251349, 55.92302434],
    visueltcenter: [11.22900255, 55.65987781],
    href: "https://api.dataforsyningen.dk/kommuner/0326",
    dagi_id: "389141",
    kode: "0326",
    navn: "Kalundborg",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [11.62790911, 55.3490168, 11.99178444, 55.56821385],
    visueltcenter: [11.8151086, 55.46909364],
    href: "https://api.dataforsyningen.dk/kommuner/0329",
    dagi_id: "389142",
    kode: "0329",
    navn: "Ringsted",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 7,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [10.93616966, 55.13307963, 11.53686764, 55.5186645],
    visueltcenter: [11.34508842, 55.36606953],
    href: "https://api.dataforsyningen.dk/kommuner/0330",
    dagi_id: "389144",
    kode: "0330",
    navn: "Slagelse",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [12.09732194, 55.23274353, 12.46639236, 55.4301754],
    visueltcenter: [12.34415856, 55.325208],
    href: "https://api.dataforsyningen.dk/kommuner/0336",
    dagi_id: "389147",
    kode: "0336",
    navn: "Stevns",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2015-10-15T21:43:23.848Z",
    bbox: [11.30867559, 55.35963382, 11.72059005, 55.59562797],
    visueltcenter: [11.55925134, 55.5248405],
    href: "https://api.dataforsyningen.dk/kommuner/0340",
    dagi_id: "389145",
    kode: "0340",
    navn: "Sorø",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2019-01-07T22:06:38.332Z",
    geo_version: 2,
    geo_ændret: "2019-01-07T22:06:38.332Z",
    bbox: [11.77002813, 55.52342585, 12.08612242, 55.74900089],
    visueltcenter: [11.91680412, 55.60544652],
    href: "https://api.dataforsyningen.dk/kommuner/0350",
    dagi_id: "389146",
    kode: "0350",
    navn: "Lejre",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-09-06T20:24:06.902Z",
    bbox: [10.94398362, 54.59189872, 11.62864481, 55.04718801],
    visueltcenter: [11.29887236, 54.80030798],
    href: "https://api.dataforsyningen.dk/kommuner/0360",
    dagi_id: "389150",
    kode: "0360",
    navn: "Lolland",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 6,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [11.42473966, 55.11024803, 12.06513421, 55.41520153],
    visueltcenter: [11.68266463, 55.29532926],
    href: "https://api.dataforsyningen.dk/kommuner/0370",
    dagi_id: "389148",
    kode: "0370",
    navn: "Næstved",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [11.51838928, 54.55466833, 12.17586824, 54.97796745],
    visueltcenter: [11.9618732, 54.82373285],
    href: "https://api.dataforsyningen.dk/kommuner/0376",
    dagi_id: "389151",
    kode: "0376",
    navn: "Guldborgsund",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2019-06-07T21:04:57.021Z",
    geo_version: 3,
    geo_ændret: "2019-06-07T21:04:57.021Z",
    bbox: [11.603971, 54.86839008, 12.56852211, 55.16240276],
    visueltcenter: [11.97379373, 55.06464257],
    href: "https://api.dataforsyningen.dk/kommuner/0390",
    dagi_id: "389149",
    kode: "0390",
    navn: "Vordingborg",
    udenforkommuneinddeling: false,
    regionskode: "1085",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1085",
      kode: "1085",
      navn: "Region Sjælland",
    },
  },
  {
    ændret: "2020-10-09T21:13:44.876Z",
    geo_version: 3,
    geo_ændret: "2020-10-09T21:13:44.876Z",
    bbox: [14.66821448, 54.98372068, 15.18772691, 55.30219618],
    visueltcenter: [14.8836754, 55.12789092],
    href: "https://api.dataforsyningen.dk/kommuner/0400",
    dagi_id: "389133",
    kode: "0400",
    navn: "Bornholm",
    udenforkommuneinddeling: false,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 3,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [9.65611933, 55.33763899, 10.0938832, 55.55586848],
    visueltcenter: [9.90786162, 55.45746884],
    href: "https://api.dataforsyningen.dk/kommuner/0410",
    dagi_id: "389156",
    kode: "0410",
    navn: "Middelfart",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-08-28T21:13:21.723Z",
    geo_version: 1,
    geo_ændret: "2018-08-28T21:13:21.723Z",
    bbox: [15.17198871, 55.31682453, 15.19914101, 55.33081105],
    visueltcenter: [15.18902826, 55.31982366],
    href: "https://api.dataforsyningen.dk/kommuner/0411",
    dagi_id: "389134",
    kode: "0411",
    navn: "Christiansø",
    udenforkommuneinddeling: true,
    regionskode: "1084",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1084",
      kode: "1084",
      navn: "Region Hovedstaden",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2017-10-05T21:08:36.021Z",
    bbox: [9.76251459, 55.11801184, 10.2977167, 55.43509178],
    visueltcenter: [10.04120662, 55.30086994],
    href: "https://api.dataforsyningen.dk/kommuner/0420",
    dagi_id: "389157",
    kode: "0420",
    navn: "Assens",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2018-01-16T22:04:55.209Z",
    bbox: [10.05646444, 55.0000628, 10.66674638, 55.34823074],
    visueltcenter: [10.36604744, 55.21254142],
    href: "https://api.dataforsyningen.dk/kommuner/0430",
    dagi_id: "389158",
    kode: "0430",
    navn: "Faaborg-Midtfyn",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2020-07-08T21:13:34.023Z",
    geo_version: 2,
    geo_ændret: "2020-07-08T21:13:34.023Z",
    bbox: [10.47501718, 55.32023063, 10.80538797, 55.6219271],
    visueltcenter: [10.57120351, 55.39108079],
    href: "https://api.dataforsyningen.dk/kommuner/0440",
    dagi_id: "389159",
    kode: "0440",
    navn: "Kerteminde",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [10.52859688, 55.17104926, 10.86220055, 55.42671861],
    visueltcenter: [10.6781976, 55.27680708],
    href: "https://api.dataforsyningen.dk/kommuner/0450",
    dagi_id: "389160",
    kode: "0450",
    navn: "Nyborg",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2020-07-13T21:09:36.091Z",
    geo_version: 3,
    geo_ændret: "2020-07-13T21:09:36.091Z",
    bbox: [10.17370248, 55.28489746, 10.58220713, 55.48395881],
    visueltcenter: [10.29848497, 55.39170385],
    href: "https://api.dataforsyningen.dk/kommuner/0461",
    dagi_id: "389161",
    kode: "0461",
    navn: "Odense",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-05-03T20:25:46.612Z",
    bbox: [10.35953648, 54.9384093, 10.88979553, 55.22805559],
    visueltcenter: [10.52326688, 55.09621323],
    href: "https://api.dataforsyningen.dk/kommuner/0479",
    dagi_id: "389162",
    kode: "0479",
    navn: "Svendborg",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 4,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [9.97690536, 55.40122942, 10.5668609, 55.6484558],
    visueltcenter: [10.16778758, 55.50599426],
    href: "https://api.dataforsyningen.dk/kommuner/0480",
    dagi_id: "389163",
    kode: "0480",
    navn: "Nordfyns",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2020-07-07T21:14:29.035Z",
    geo_version: 3,
    geo_ændret: "2020-07-07T21:14:29.035Z",
    bbox: [10.52601837, 54.71828064, 10.95659121, 55.17036019],
    visueltcenter: [10.70871186, 54.81986089],
    href: "https://api.dataforsyningen.dk/kommuner/0482",
    dagi_id: "389164",
    kode: "0482",
    navn: "Langeland",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2020-07-07T21:14:29.035Z",
    geo_version: 2,
    geo_ændret: "2020-07-07T21:14:29.035Z",
    bbox: [10.1997863, 54.81472434, 10.55050184, 54.9718452],
    visueltcenter: [10.39952748, 54.85586896],
    href: "https://api.dataforsyningen.dk/kommuner/0492",
    dagi_id: "389165",
    kode: "0492",
    navn: "Ærø",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 4,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [8.88446212, 55.12416586, 9.78105211, 55.38256355],
    visueltcenter: [9.29762312, 55.24461821],
    href: "https://api.dataforsyningen.dk/kommuner/0510",
    dagi_id: "389166",
    kode: "0510",
    navn: "Haderslev",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-01-06T21:28:13.316Z",
    bbox: [8.74656855, 55.59327862, 9.20003685, 55.89566936],
    visueltcenter: [9.00651005, 55.69765926],
    href: "https://api.dataforsyningen.dk/kommuner/0530",
    dagi_id: "389172",
    kode: "0530",
    navn: "Billund",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2017-07-06T21:17:20.661Z",
    bbox: [9.46135543, 54.83227225, 10.07704472, 55.08527472],
    visueltcenter: [9.94828845, 54.94264465],
    href: "https://api.dataforsyningen.dk/kommuner/0540",
    dagi_id: "389167",
    kode: "0540",
    navn: "Sønderborg",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 4,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [8.46048936, 54.88033268, 9.25030869, 55.24477042],
    visueltcenter: [8.85683082, 55.04435506],
    href: "https://api.dataforsyningen.dk/kommuner/0550",
    dagi_id: "389168",
    kode: "0550",
    navn: "Tønder",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 8,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [8.29241679, 55.21869154, 8.93899786, 55.59856647],
    visueltcenter: [8.72094847, 55.46178607],
    href: "https://api.dataforsyningen.dk/kommuner/0561",
    dagi_id: "389170",
    kode: "0561",
    navn: "Esbjerg",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 1,
    geo_ændret: "2014-11-04T15:16:59.935Z",
    bbox: [8.32757711, 55.3380498, 8.53502645, 55.47482216],
    visueltcenter: [8.42104862, 55.40607728],
    href: "https://api.dataforsyningen.dk/kommuner/0563",
    dagi_id: "389171",
    kode: "0563",
    navn: "Fanø",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2019-01-07T22:06:38.332Z",
    geo_version: 4,
    geo_ændret: "2019-01-07T22:06:38.332Z",
    bbox: [8.06575777, 55.47534498, 8.91478282, 55.85062236],
    visueltcenter: [8.60622686, 55.68693144],
    href: "https://api.dataforsyningen.dk/kommuner/0573",
    dagi_id: "389173",
    kode: "0573",
    navn: "Varde",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 4,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [8.76175841, 55.28909667, 9.30438073, 55.62773209],
    visueltcenter: [9.0502437, 55.49285528],
    href: "https://api.dataforsyningen.dk/kommuner/0575",
    dagi_id: "389174",
    kode: "0575",
    navn: "Vejen",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2020-06-09T21:10:00.930Z",
    geo_version: 3,
    geo_ændret: "2020-06-09T21:10:00.930Z",
    bbox: [9.00493691, 54.799098, 9.63421752, 55.16837172],
    visueltcenter: [9.27705335, 54.95857106],
    href: "https://api.dataforsyningen.dk/kommuner/0580",
    dagi_id: "389169",
    kode: "0580",
    navn: "Aabenraa",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 6,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [9.55675444, 55.50773223, 9.85981944, 55.62963341],
    visueltcenter: [9.65516922, 55.5644429],
    href: "https://api.dataforsyningen.dk/kommuner/0607",
    dagi_id: "389175",
    kode: "0607",
    navn: "Fredericia",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 8,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [9.45942285, 55.74087123, 10.37380446, 56.07069093],
    visueltcenter: [9.7992371, 55.90694512],
    href: "https://api.dataforsyningen.dk/kommuner/0615",
    dagi_id: "389179",
    kode: "0615",
    navn: "Horsens",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 6,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [9.21439766, 55.30750617, 9.69638424, 55.63058106],
    visueltcenter: [9.40397607, 55.42632798],
    href: "https://api.dataforsyningen.dk/kommuner/0621",
    dagi_id: "389176",
    kode: "0621",
    navn: "Kolding",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2021-06-09T21:01:24.204Z",
    geo_version: 12,
    geo_ændret: "2021-06-09T21:01:24.204Z",
    bbox: [9.05449491, 55.56517972, 9.75605304, 55.95679785],
    visueltcenter: [9.36401747, 55.69959549],
    href: "https://api.dataforsyningen.dk/kommuner/0630",
    dagi_id: "389177",
    kode: "0630",
    navn: "Vejle",
    udenforkommuneinddeling: false,
    regionskode: "1083",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1083",
      kode: "1083",
      navn: "Region Syddanmark",
    },
  },
  {
    ændret: "2019-06-11T21:04:49.731Z",
    geo_version: 12,
    geo_ændret: "2019-06-11T21:04:49.731Z",
    bbox: [8.43127771, 55.87838076, 9.18963076, 56.41389516],
    visueltcenter: [8.89416342, 56.21557089],
    href: "https://api.dataforsyningen.dk/kommuner/0657",
    dagi_id: "389181",
    kode: "0657",
    navn: "Herning",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 6,
    geo_ændret: "2018-01-16T22:04:55.209Z",
    bbox: [8.10908932, 56.22607312, 9.00268776, 56.5663316],
    visueltcenter: [8.82845597, 56.42999591],
    href: "https://api.dataforsyningen.dk/kommuner/0661",
    dagi_id: "389182",
    kode: "0661",
    navn: "Holstebro",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2020-08-11T21:09:28.469Z",
    geo_version: 8,
    geo_ændret: "2020-08-11T21:09:28.469Z",
    bbox: [8.10933285, 56.34631007, 8.52717395, 56.71214576],
    visueltcenter: [8.28872694, 56.47238735],
    href: "https://api.dataforsyningen.dk/kommuner/0665",
    dagi_id: "389183",
    kode: "0665",
    navn: "Lemvig",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 6,
    geo_ændret: "2018-01-01T22:10:40.972Z",
    bbox: [8.38803654, 56.38698393, 8.71302733, 56.69363721],
    visueltcenter: [8.57605615, 56.4553439],
    href: "https://api.dataforsyningen.dk/kommuner/0671",
    dagi_id: "389185",
    kode: "0671",
    navn: "Struer",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2020-01-15T22:18:08.104Z",
    geo_version: 9,
    geo_ændret: "2020-01-15T22:18:08.104Z",
    bbox: [10.15322093, 56.09021607, 10.8544574, 56.45256826],
    visueltcenter: [10.51126857, 56.35748628],
    href: "https://api.dataforsyningen.dk/kommuner/0706",
    dagi_id: "389186",
    kode: "0706",
    navn: "Syddjurs",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2020-01-15T22:18:08.104Z",
    geo_version: 5,
    geo_ændret: "2020-01-15T22:18:08.104Z",
    bbox: [10.21228126, 56.28091155, 11.65848576, 56.75998911],
    visueltcenter: [10.75849132, 56.46479679],
    href: "https://api.dataforsyningen.dk/kommuner/0707",
    dagi_id: "389187",
    kode: "0707",
    navn: "Norddjurs",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2019-01-07T22:06:38.332Z",
    geo_version: 4,
    geo_ændret: "2019-01-07T22:06:38.332Z",
    bbox: [9.65853159, 56.18511894, 10.24502597, 56.45096948],
    visueltcenter: [9.91776151, 56.29367722],
    href: "https://api.dataforsyningen.dk/kommuner/0710",
    dagi_id: "389188",
    kode: "0710",
    navn: "Favrskov",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2020-07-06T21:09:22.479Z",
    geo_version: 3,
    geo_ændret: "2020-07-06T21:09:22.479Z",
    bbox: [10.00989488, 55.83339242, 10.46639622, 56.02630794],
    visueltcenter: [10.14601199, 55.94116424],
    href: "https://api.dataforsyningen.dk/kommuner/0727",
    dagi_id: "389189",
    kode: "0727",
    navn: "Odder",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 5,
    geo_ændret: "2018-01-01T22:10:40.972Z",
    bbox: [9.77459844, 56.36614977, 10.36495871, 56.7180007],
    visueltcenter: [10.08975635, 56.53736978],
    href: "https://api.dataforsyningen.dk/kommuner/0730",
    dagi_id: "389190",
    kode: "0730",
    navn: "Randers",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 5,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [9.22086697, 55.9918709, 9.86539594, 56.37012378],
    visueltcenter: [9.56059412, 56.20903115],
    href: "https://api.dataforsyningen.dk/kommuner/0740",
    dagi_id: "389192",
    kode: "0740",
    navn: "Silkeborg",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-08-11T22:11:04.361Z",
    bbox: [10.51206998, 55.76203722, 10.79650888, 56.0028711],
    visueltcenter: [10.58611812, 55.80308366],
    href: "https://api.dataforsyningen.dk/kommuner/0741",
    dagi_id: "389191",
    kode: "0741",
    navn: "Samsø",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 4,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [9.63068161, 55.95220047, 10.09706899, 56.21901825],
    visueltcenter: [9.84907585, 56.08709974],
    href: "https://api.dataforsyningen.dk/kommuner/0746",
    dagi_id: "389193",
    kode: "0746",
    navn: "Skanderborg",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-02-08T22:11:44.228Z",
    geo_version: 7,
    geo_ændret: "2021-02-08T22:11:44.228Z",
    bbox: [9.94493961, 55.99248646, 10.39098148, 56.33280109],
    visueltcenter: [10.10360521, 56.15511031],
    href: "https://api.dataforsyningen.dk/kommuner/0751",
    dagi_id: "389194",
    kode: "0751",
    navn: "Aarhus",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-01-01T22:14:53.992Z",
    geo_version: 8,
    geo_ændret: "2021-01-01T22:14:53.992Z",
    bbox: [8.95731716, 55.82939305, 9.5645757, 56.27618886],
    visueltcenter: [9.23109529, 56.14494181],
    href: "https://api.dataforsyningen.dk/kommuner/0756",
    dagi_id: "389180",
    kode: "0756",
    navn: "Ikast-Brande",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-10-05T21:01:44.324Z",
    geo_version: 11,
    geo_ændret: "2021-10-05T21:01:44.324Z",
    bbox: [8.09288669, 55.77099116, 8.86542531, 56.26529221],
    visueltcenter: [8.54072392, 56.02237771],
    href: "https://api.dataforsyningen.dk/kommuner/0760",
    dagi_id: "389184",
    kode: "0760",
    navn: "Ringkøbing-Skjern",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-02-19T22:17:46.759Z",
    geo_version: 8,
    geo_ændret: "2021-02-19T22:17:46.759Z",
    bbox: [9.38384648, 55.66667969, 10.10465758, 55.92589889],
    visueltcenter: [9.82272174, 55.73776272],
    href: "https://api.dataforsyningen.dk/kommuner/0766",
    dagi_id: "389178",
    kode: "0766",
    navn: "Hedensted",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2017-02-17T01:34:35.603Z",
    bbox: [8.49851263, 56.66822122, 9.01229249, 56.98465809],
    visueltcenter: [8.70784316, 56.75308553],
    href: "https://api.dataforsyningen.dk/kommuner/0773",
    dagi_id: "389197",
    kode: "0773",
    navn: "Morsø",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 2,
    geo_ændret: "2016-05-11T20:30:36.642Z",
    bbox: [8.67249986, 56.48877643, 9.29747919, 56.84629988],
    visueltcenter: [8.91330847, 56.6199892],
    href: "https://api.dataforsyningen.dk/kommuner/0779",
    dagi_id: "389195",
    kode: "0779",
    navn: "Skive",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2021-08-27T21:01:36.955Z",
    geo_version: 3,
    geo_ændret: "2021-08-27T21:01:36.955Z",
    bbox: [8.20276612, 56.66934321, 9.09626885, 57.15902547],
    visueltcenter: [8.47287088, 56.89372267],
    href: "https://api.dataforsyningen.dk/kommuner/0787",
    dagi_id: "389198",
    kode: "0787",
    navn: "Thisted",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 11,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [8.97156904, 56.2160919, 9.79886952, 56.68426527],
    visueltcenter: [9.54980131, 56.47080654],
    href: "https://api.dataforsyningen.dk/kommuner/0791",
    dagi_id: "389196",
    kode: "0791",
    navn: "Viborg",
    udenforkommuneinddeling: false,
    regionskode: "1082",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1082",
      kode: "1082",
      navn: "Region Midtjylland",
    },
  },
  {
    ændret: "2018-11-07T22:06:37.237Z",
    geo_version: 4,
    geo_ændret: "2018-11-07T22:06:37.237Z",
    bbox: [9.73560852, 57.06944718, 10.44883359, 57.34353124],
    visueltcenter: [10.27821906, 57.17989923],
    href: "https://api.dataforsyningen.dk/kommuner/0810",
    dagi_id: "389199",
    kode: "0810",
    navn: "Brønderslev",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2022-03-09T22:01:55.638Z",
    geo_version: 9,
    geo_ændret: "2022-03-09T22:01:55.638Z",
    bbox: [10.17723301, 57.16783887, 10.65245684, 57.75720105],
    visueltcenter: [10.41373901, 57.32317454],
    href: "https://api.dataforsyningen.dk/kommuner/0813",
    dagi_id: "389200",
    kode: "0813",
    navn: "Frederikshavn",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 9,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [9.06789008, 56.63600364, 9.66293337, 57.03084543],
    visueltcenter: [9.38374995, 56.81543648],
    href: "https://api.dataforsyningen.dk/kommuner/0820",
    dagi_id: "389207",
    kode: "0820",
    navn: "Vesthimmerlands",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2018-08-28T21:13:21.723Z",
    geo_version: 2,
    geo_ændret: "2018-08-28T21:13:21.723Z",
    bbox: [10.85363272, 57.17080979, 11.20274004, 57.36571655],
    visueltcenter: [11.0080114, 57.26614235],
    href: "https://api.dataforsyningen.dk/kommuner/0825",
    dagi_id: "389203",
    kode: "0825",
    navn: "Læsø",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 9,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [9.51710501, 56.64718841, 10.23384165, 56.97247531],
    visueltcenter: [9.76037733, 56.86903928],
    href: "https://api.dataforsyningen.dk/kommuner/0840",
    dagi_id: "389204",
    kode: "0840",
    navn: "Rebild",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2022-01-01T22:03:37.058Z",
    geo_version: 11,
    geo_ændret: "2022-01-01T22:03:37.058Z",
    bbox: [9.52627993, 56.54612178, 10.33975292, 56.86569281],
    visueltcenter: [9.92557558, 56.73357041],
    href: "https://api.dataforsyningen.dk/kommuner/0846",
    dagi_id: "389202",
    kode: "0846",
    navn: "Mariagerfjord",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 4,
    geo_ændret: "2016-02-23T21:20:29.146Z",
    bbox: [9.02986622, 57.00444952, 9.92424054, 57.35757954],
    visueltcenter: [9.62199119, 57.16563593],
    href: "https://api.dataforsyningen.dk/kommuner/0849",
    dagi_id: "389205",
    kode: "0849",
    navn: "Jammerbugt",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2018-11-07T22:06:37.237Z",
    geo_version: 8,
    geo_ændret: "2018-11-07T22:06:37.237Z",
    bbox: [9.38901906, 56.80924853, 10.39465954, 57.23315204],
    visueltcenter: [9.99710026, 56.98086976],
    href: "https://api.dataforsyningen.dk/kommuner/0851",
    dagi_id: "389206",
    kode: "0851",
    navn: "Aalborg",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
  {
    ændret: "2018-04-30T15:23:13.528Z",
    geo_version: 4,
    geo_ændret: "2018-01-16T22:04:55.209Z",
    bbox: [9.68890908, 57.30159339, 10.41717858, 57.62306127],
    visueltcenter: [10.07790672, 57.4684031],
    href: "https://api.dataforsyningen.dk/kommuner/0860",
    dagi_id: "389201",
    kode: "0860",
    navn: "Hjørring",
    udenforkommuneinddeling: false,
    regionskode: "1081",
    region: {
      href: "https://api.dataforsyningen.dk/regioner/1081",
      kode: "1081",
      navn: "Region Nordjylland",
    },
  },
];
